/* global axios */
import ApiClient from './ApiClient';

// Todos os endpoints do relatório recebem os mesmos filtros; min_cycle_minutes
// e min_cycle_scope descartam ciclos fechados curtos (ver AppliedSla scope).
const reportParams = ({
  from,
  to,
  assigned_agent_id,
  inbox_id,
  team_id,
  sla_policy_id,
  label_list,
  min_cycle_minutes,
  min_cycle_scope,
} = {}) => ({
  since: from,
  until: to,
  assigned_agent_id,
  inbox_id,
  team_id,
  sla_policy_id,
  label_list,
  min_cycle_minutes,
  min_cycle_scope,
});

class SLAReportsAPI extends ApiClient {
  constructor() {
    super('applied_slas', { accountScoped: true });
  }

  get({ page, ...filters } = {}) {
    return axios.get(this.url, {
      params: { ...reportParams(filters), page },
    });
  }

  download(filters = {}) {
    return axios.get(`${this.url}/download`, {
      params: reportParams(filters),
    });
  }

  getMetrics(filters = {}) {
    return axios.get(`${this.url}/metrics`, {
      params: reportParams(filters),
    });
  }

  // Quadro por agente: ciclos, cumpridos, perdidos e taxa por responsável do ciclo.
  getAgents(filters = {}) {
    return axios.get(`${this.url}/agents`, {
      params: reportParams(filters),
    });
  }
}

export default new SLAReportsAPI();
